import { TSafetySummaryDashboardListSettingsItem } from '../types/types';

export const SAFETY_SUMMARY_SETTINGS_KEY = 'safetySummary';

export const safetySummaryDefaultSummaryItems: TSafetySummaryDashboardListSettingsItem[] = [
  {
    id: 'inspections',
    visible: true,
  },
  {
    id: 'incidents',
    visible: true,
  },
  {
    id: 'observations',
    visible: true,
  },
  {
    id: 'training',
    visible: true,
  },
  {
    id: 'jsaReports',
    visible: true,
  },
];
